<template>
  <div class="wrapper">
    <div class="content">
      <div class="container">
        <div>
          金箱云仓是一个由平台管理系统、企业管理系统、企业奉客
          盘、企业app、企业大屏这5个端组成的数字化、智能化管理
          系统。专注于贵金属货品的智能监管, 服务于企业的货品生产
          流转保管以及门店销售等过程，用信息化，数字化技术帮助企
          业减少运营成本，提高业务处理的安全性、便捷性、高效性！
        </div>
        <div class="tips">1、平台管理系统</div>
        <div>
          1、平台管理系统 PC端交互方式，提供平台运营团队，完成包括企业入驻审核
          、通用类数据构建、业务授权、风控审核、数据可视化统计
          精分等平台运营操作
        </div>
        <div>
          2、PC端交互方式，提供企业运营团队，完成包括工厂/门店
          入驻、组织架构管理、货品数据构建、数据统计精分等企业 操作
        </div>
        <div class="tips">2、企业奉客盘</div>
        <div>
          硬能力：拍照录像、码签识别、测重、场景
          软服务：多维对比、业务闭环、时空存证
          现场协助：数据构建、仓储业务、盘点抽验、销售支持
        </div>
        <div class="tips">3、企业app</div>
        <div>
          动态监控整个黄金供应链中货品的流通和监管，做到了智能
          、安全、高效。员工单据、仓库单据等等
        </div>
        <div class="tips">4、企业数据大屏</div>
        <div>
          展示企业新增 / 活跃情况以及企业的产业分布情况，仓库的
          数量以及总货值，质押值，业务、货品、风控、智能硬件等
          数据信息让企业经营者能够快速，精准的通过一些信息准确
          的把控企业的各项数据情况
        </div>
      </div>
      <div class="documentName">
        文档名称：
        <div>平台介绍</div>
      </div>
      <div class="updateDate">版本更新日期：2022-8-26</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="less" scoped>
@import "./introduction.less";
</style>
